var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelDisplayAd = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  viewBox: "0 0 60 60",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M57.004 0A2.993 2.993 0 0 1 60 2.996v54.008A2.993 2.993 0 0 1 57.004 60h-8.922l-6.457-15.982 8.285-.359c1.595-.07 2.03-1.03 1.015-2.17l-.11-.119-23.751-24.564c-1.159-1.198-2.089-.815-2.09.844l-.021 34.17c-.001 1.666 1.005 2.115 2.248 1.02l6.214-5.472L38.518 60H2.996A2.993 2.993 0 0 1 0 57.004V2.996A2.993 2.993 0 0 1 2.996 0z"
})));
export default SvgChannelDisplayAd;